module.exports = __webpack_public_path__ + "static/media/emot3_off.f6fea093.svg";